import React, { useEffect, useState } from "react";
import { Col, Row } from "react-bootstrap";
import SaveIcon from "../../assets/icons/save.svg2";
import TickIcon from "../../assets/icons/tick.svg2";
import {
  WeatherAlertConditions,
  WeatherAlertOperators,
} from "../WeatherAlerts/WeatherAlertConstants";
import { proxyAPI } from "../proxyAPI";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faMinus, faSquare } from "@fortawesome/free-solid-svg-icons";
import { unitConversions } from "./WeatherAlertConstants";
import { pageProps } from "../helpers/pageProps";

function MonitoringComplete({ monitor, errors: e, selectedApiDetails }) {
  const [shapeName, setShapeName] = useState("asd");
  const [projectData, setProjectData] = useState();

  const getProjectData = async (projectID) => {
    const projectData = await proxyAPI({
      prefix: "logic/workflows/api",
      url: `/project/${projectID}`,
      setLoading: () => null,
    });

    setProjectData(projectData);
  };

  useEffect(() => {
    if (!monitor.WeatherAlert?.Projects?.length) return;

    getProjectData(monitor.WeatherAlert?.Projects?.[0]?.ProjectId);
  }, [monitor.WeatherAlert?.Projects?.[0]?.ProjectId]);

  useEffect(() => {
    if (!monitor?.WeatherAlert?.ShapeId) return;
    if (monitor.WeatherAlert?.GeoUnitType === "county") {
      (async () => {
        const data = await proxyAPI({
          prefix: "logic/workflows/api",
          url: `geo/shapes?id=${monitor.WeatherAlert?.ShapeId}`,
        });
        setShapeName(data?.shapes[0]?.Name || "Unknown Shape");
      })();
    }
  }, [monitor?.WeatherAlert?.ShapeId]);

  const errors = e.reduce(
    (acc, val) => ({
      ...(acc || {}),
      ...Object.entries(val).reduce((a, v) => ({ ...a, [v[0]]: v[1] }), {}),
    }),
    {}
  );

  return (
    <div>
      <Row className="mx-5 mt-3">
        <Col xl={5} className="border-end">
          <div
            className="d-flex flex-column align-items-center justify-content-center"
            style={{ minHeight: 400 }}
          >
            <div className="mb-3">
              <SaveIcon width={60} />
            </div>
            <div className="fs-4 fw-bold ">
              {errors?.length
                ? "There are errors in your monitor configuration"
                : monitor.Uuid
                ? "Monitor saved"
                : "Monitor is ready to be saved"}
            </div>
            <div className="text-secondary w-75">
              Your monitor has been successfully saved and is now actively
              tracking according to your chosen settings.
            </div>
          </div>
        </Col>
        <Col xl={7}>
          <div className="ms-3 px-5">
            <span className="fs-4 fw-bold "> Summary of this Monitor...</span>
            <div className="mt-3">
              <span className="d-flex align-items-center">
                <TickIcon width={15} className="text-purple " />
                <div className=" p-1 small ms-2 ">
                  What to monitor: {monitor.Kind}
                </div>
              </span>
              <span className="d-flex align-items-center">
                <TickIcon width={15} className="text-purple" />
                <div className=" p-1 small ms-2">
                  Monitor Reference : {monitor.Reference}
                </div>
              </span>{" "}
              <span className="d-flex align-items-center">
                <TickIcon width={15} className="text-purple" />
                <div className=" p-1 small ms-2">
                  Monitor Label: {monitor.Label}
                </div>
              </span>{" "}
              <span className="d-flex align-items-center">
                <TickIcon width={15} className="text-purple" />
                <div className=" p-1 small ms-2">
                  Monitor Description: {monitor.Description}
                </div>
              </span>
              <span className="d-flex align-items-center">
                <TickIcon width={15} className="text-purple" />
                <div className=" p-1 small ms-2">
                  Monitor Priority: {monitor.Priority}
                </div>
              </span>
              {selectedApiDetails?.Profile && (
                <span className="d-flex align-items-center">
                  <TickIcon width={15} className="text-purple" />
                  <div className=" p-1 small ms-2">
                    Monitor BaseUrl: {selectedApiDetails?.Profile.BaseUrl}
                  </div>
                </span>
              )}
            </div>
            {monitor.WeatherAlert && (
              <span className="d-flex align-items-center">
                <TickIcon width={15} className="text-purple" />
                <div className=" p-1 small ms-2">
                  Weather alert description: {monitor.WeatherAlert?.Description}
                </div>
              </span>
            )}
            {monitor.WeatherAlert && (
              <span className="d-flex align-items-center">
                <TickIcon width={15} className="text-purple" />
                <div className=" p-1 small ms-2">
                  Weather alert location:{" "}
                  {monitor.WeatherAlert?.CountryIso && (
                    <span className="me-1">
                      Country:{" "}
                      {
                        pageProps.countries.find(
                          (c) =>
                            c.country_code === monitor.WeatherAlert?.CountryIso
                        )?.country_name
                      }
                    </span>
                  )}
                  {monitor.WeatherAlert?.GeoUnitType === "county" && (
                    <span className="me-1 text-capitalize">
                      {" "}
                      / {monitor.WeatherAlert?.GeoUnitType}: {shapeName}
                    </span>
                  )}
                  {monitor.WeatherAlert?.GeoUnitType === "region" && (
                    <span className="me-1 text-capitalize">
                      {" "}
                      / {monitor.WeatherAlert?.GeoUnitType}:{" "}
                      {monitor.WeatherAlert?.GroupName}
                    </span>
                  )}
                </div>
              </span>
            )}
            {monitor.WeatherAlert && (
              <span className="d-flex align-items-start">
                <TickIcon width={15} className="text-purple mt-2" />
                <div className=" p-1 py-0 small ms-2 ">
                  Weather alert conditions:{" "}
                  {monitor.WeatherAlert?.Conditions?.map((c) => (
                    <>
                      <div className="my-1">
                        <FontAwesomeIcon
                          className="me-1"
                          icon={faMinus}
                          style={{ color: "purple" }}
                        />{" "}
                        Description: {c.Description}
                      </div>
                      <div className="my-1">
                        <FontAwesomeIcon
                          className="me-1"
                          icon={faMinus}
                          style={{ color: "purple" }}
                        />{" "}
                        Days Ahead:{" "}
                        {c.DaysAhead?.map((day, index) => (
                          <span key={index} className="badge bg-secondary me-1">
                            {day === 0
                              ? "Today"
                              : day === 1
                              ? "Tomorrow"
                              : day + " days ahead"}
                          </span>
                        ))}
                      </div>
                      <div className="my-1">
                        {" "}
                        <FontAwesomeIcon
                          className="me-1"
                          icon={faMinus}
                          style={{ color: "purple" }}
                        />{" "}
                        Color:{" "}
                        <FontAwesomeIcon
                          icon={faSquare}
                          style={{ color: c.Color }}
                        />
                      </div>
                      <div>
                        {" "}
                        <FontAwesomeIcon
                          className="me-1"
                          icon={faMinus}
                          style={{ color: "purple" }}
                        />{" "}
                        Order: {c.Order}
                      </div>
                      {c.ConditionDetails.map((cd) => (
                        <>
                          <span className="my-3 fw-bold">
                            Condition details
                          </span>{" "}
                          <div>
                            <div className="my-1">
                              <FontAwesomeIcon
                                className="me-1"
                                icon={faMinus}
                                style={{ color: "purple" }}
                              />{" "}
                              Time of Day:{" "}
                              <span className="text-capitalize">
                                {cd.TimeOfDay === "both"
                                  ? "day and night"
                                  : cd.TimeOfDay}
                              </span>
                            </div>
                            <div className="my-1">
                              {" "}
                              <FontAwesomeIcon
                                className="me-1"
                                icon={faMinus}
                                style={{ color: "purple" }}
                              />{" "}
                              Condition:{" "}
                              {WeatherAlertConditions.find(
                                (wac) => wac.key === cd.Condition
                              )?.label || "Unknown Condition"}
                            </div>
                            <div className="my-1">
                              {" "}
                              <FontAwesomeIcon
                                className="me-1"
                                icon={faMinus}
                                style={{ color: "purple" }}
                              />{" "}
                              Condition Operator:{" "}
                              {WeatherAlertOperators.find(
                                (wao) => wao.symbol === cd.ConditionOperator
                              )?.desc || "Unknown Operator"}
                            </div>
                            <div className="my-1">
                              <FontAwesomeIcon
                                className="me-1"
                                icon={faMinus}
                                style={{ color: "purple" }}
                              />{" "}
                              Condition Value:{" "}
                              {unitConversions[cd.conditionUnit]?.conversions
                                ?.find(
                                  (conversion) => conversion.to === cd.Unit
                                )
                                ?.convert(parseFloat(cd.ConditionValue))}{" "}
                              {cd.Unit}
                            </div>
                            <div className="my-1">
                              {" "}
                              <FontAwesomeIcon
                                className="me-1"
                                icon={faMinus}
                                style={{ color: "purple" }}
                              />{" "}
                              Condition Helper: {cd.conditionHelper}
                            </div>
                          </div>
                        </>
                      ))}
                    </>
                  ))}
                </div>
              </span>
            )}
            {monitor.WeatherAlert && projectData && (
              <span className="d-flex align-items-start">
                <TickIcon width={15} className="text-purple mt-2" />
                <div className=" p-1 py-0 small ms-2">
                  <div>
                    <span className="my-3 fw-bold">Project details</span>
                    <div className="my-1">
                      <FontAwesomeIcon
                        className="me-1"
                        icon={faMinus}
                        style={{ color: "purple" }}
                      />{" "}
                      Name: {projectData?.Label}
                    </div>
                    <div className="my-1">
                      {" "}
                      <FontAwesomeIcon
                        className="me-1"
                        icon={faMinus}
                        style={{ color: "purple" }}
                      />{" "}
                      Description : {projectData?.Description}
                    </div>
                    <div className="my-1">
                      {" "}
                      <FontAwesomeIcon
                        className="me-1"
                        icon={faMinus}
                        style={{ color: "purple" }}
                      />{" "}
                      Reference: {projectData?.Reference}
                    </div>
                    <div>
                      {" "}
                      <FontAwesomeIcon
                        className="me-1"
                        icon={faMinus}
                        style={{ color: "purple" }}
                      />{" "}
                      Status: {projectData?.Status}
                    </div>
                    <div>
                      {" "}
                      <FontAwesomeIcon
                        className="me-1"
                        icon={faMinus}
                        style={{ color: "purple" }}
                      />{" "}
                      Created by: {projectData?.CreatedBy}
                    </div>{" "}
                    <div>
                      {" "}
                      <FontAwesomeIcon
                        className="me-1"
                        icon={faMinus}
                        style={{ color: "purple" }}
                      />{" "}
                      Status: {projectData?.Status}
                    </div>{" "}
                    <div>
                      {" "}
                      <FontAwesomeIcon
                        className="me-1"
                        icon={faMinus}
                        style={{ color: "purple" }}
                      />{" "}
                      Time zone:{" "}
                      {projectData?.TimeZone ||
                        `${pageProps.defaultTZ} (default)`}
                    </div>
                  </div>
                </div>
              </span>
            )}
          </div>
        </Col>
      </Row>
    </div>
  );
}

export default MonitoringComplete;
